import { columnTextField } from "utils/tables-utils";

import ImagePlaceholder from "components/Image/ImagePlaceholder";
import { Tooltip } from "@mui/material";

export function readProductGradeFields(row) {
  return {
    grade:
      String(
        row?.GradeVenda ?? row?.gradeVenda ?? row?.nome ?? row?.Nome ?? "",
      ).trim() || "",
    subgrade: String(
      row?.SubgradeVenda ?? row?.subgradeVenda ?? row?.subgrade ?? "",
    ).trim(),
    tamanho: String(
      row?.TamanhoGrade ??
        row?.tamanhoGrade ??
        row?.tamanho ??
        row?.TamanhoMedidas ??
        "",
    ).trim(),
  };
}

export function buildShowcaseProductGradeColumns({
  includeImage = true,
  includeDescricao = false,
} = {}) {
  const columns = [
    columnTextField({
      dataField: "Codigo",
      text: "Cód. Produto",
      align: "center",
    }),
    columnTextField({
      dataField: "GradeVenda",
      text: "Nome comercial/Grade",
      align: "left",
      formatter: (_, row) => readProductGradeFields(row).grade,
    }),
    ...(includeDescricao
      ? [
          columnTextField({
            dataField: "Descricao",
            text: "Descrição",
            align: "center",
            formatter: (_, row) => {
              const description =
                String(row?.Descricao ?? row?.descricao ?? "").trim() || "—";
              return (
                <Tooltip title={description}>
                  <div
                    style={{
                      width: "200px",
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {description}
                  </div>
                </Tooltip>
              );
            },
          }),
        ]
      : []),
    columnTextField({
      dataField: "SubgradeVenda",
      text: "Sub-grade",
      align: "center",
      formatter: (_, row) => readProductGradeFields(row).subgrade,
    }),
    columnTextField({
      dataField: "TamanhoGrade",
      text: "Tamanho",
      align: "center",
      formatter: (_, row) => readProductGradeFields(row).tamanho,
    }),
    columnTextField({
      dataField: "Marca",
      text: "Marca",
      align: "center",
    }),
    columnTextField({
      dataField: "Colecao",
      text: "Coleção",
      align: "center",
      formatter: (_, row) =>
        String(row?.Colecao ?? row?.colecao ?? "").trim() || "—",
    }),
    columnTextField({
      dataField: "Estoque",
      text: "Estoque",
      align: "center",
      formatter: (_, row) => {
        const valor = row?.Estoque ?? row?.estoque;
        return valor == null ? "—" : String(valor);
      },
    }),
  ];

  if (includeImage) {
    columns.push(
      columnTextField({
        dataField: "FotoPrincipal",
        text: "Imagem",
        align: "center",
        formatter: (_, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ImagePlaceholder
              src={row?.FotoPrincipal ?? row?.foto}
              alt={`Imagem do produto ${row?.Codigo}`}
              width="50px"
              height="50px"
              widthOnError="50px"
              heightOnError="50px"
            />
          </div>
        ),
      }),
    );
  }

  return columns;
}
